import { Feature, FeatureState } from 'src/ts/enums';
import { IPropertyFeature } from 'src/ts/interfaces';

export const NAME = 'propertyFeature';

export const DEFAULT_PROPERTY_FEATURES: IPropertyFeature[] = [
  {
    name: 'Income Verification',
    code: Feature.INCOME_VERIFICATION,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Connected Payroll',
    code: Feature.PAYROLL_LINKING,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Bank Linking',
    code: Feature.BANK_LINKING,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Identity Verification',
    code: Feature.IDENTITY_VERIFICATION,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Identity Verification Only Web Portal',
    code: Feature.IDENTITY_VERIFICATION_ONLY_WEB_PORTAL,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Asset Verification',
    code: Feature.ASSET_VERIFICATION,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Rental History',
    code: Feature.RENTAL_HISTORY,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Tax Linking',
    code: Feature.TAX_LINKING,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Reference Completed Notification',
    code: Feature.REFERENCE_COMPLETED_NOTIFICATION,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'CPN Fraud Check',
    code: Feature.CPN_FRAUD_CHECK,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Offer Letter Verification',
    code: Feature.OFFER_LETTER_VERIFICATION,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Auto Employment Verification',
    code: Feature.AUTO_EMPLOYMENT_VERIFICATION,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Auto Employment Verification (Always On)',
    code: Feature.AUTO_EMPLOYMENT_VERIFICATION_ALWAYS_ON,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Verify My Way',
    code: Feature.VERIFY_MY_WAY,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Verify My Way (Basic)',
    code: Feature.VERIFY_MY_WAY_BASIC,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Enhanced Financial',
    code: Feature.ENHANCED_FINANCIAL,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'On Behalf Of',
    code: Feature.ON_BEHALF_OF,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'On Behalf Of Signature Required',
    code: Feature.ON_BEHALF_OF_SIGNATURE_REQUIRED,
    state: FeatureState.DISABLED,
    config: {}
  },
  {
    name: 'Disable Property Links',
    code: Feature.DISABLE_PROPERTY_LINKS,
    state: FeatureState.DISABLED,
    config: {}
  }
];
